import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@usitsdasdesign/dds-react';
import InputBox from 'atoms/InputBox';
import { useRouter } from 'hooks/navigation-router-with-loading';
import { getSession, signIn } from 'next-auth/react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { sendLoginOtp } from 'services/auth.service';
import * as yup from 'yup';

export default function LoginWithOTP() {
    const router = useRouter();
    const [otpSent, setOtpSent] = useState(false);
    const emailRegex = (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm({
        mode: 'onChange',
        resolver: yupResolver(
            yup.object({
                email: yup.string().required('Email is required!')
            })
        )
    });

    async function submitHandler(data) {
        const { email, otp } = data;

        if (otpSent) {
            const res = await signIn('otp', { redirect: false, email, otp });
            if (!res.error && res.ok && res.status == 200) {
                const session = await getSession();
                const { role = [], gradeLevel } = session.user;
                const { resourceId } = session.user;
                const userRoles = {
                    isSuperAdmin: role.includes('super_admin'),
                    isAdmin: role.includes('admin'),
                    isRM: role.includes('resource_manager'),
                    isRmLead: role.includes('resource_manager_lead'),
                    isBusinessTeam: role.includes('business_team'),
                    isGuestRm: role.includes('guest_rm'),
                    isTalentAdvisor: role.includes('talent_advisor'),
                    isTpcrRm: role.includes('tpcr_rm'),
                    isTpcrRmLead: role.includes('tpcr_rm_lead')
                };
                const isPodLead = role.includes('pod_lead');

                const hasSpecialRole = Object.values(userRoles).some(hasRole => hasRole);
                const isResource = gradeLevel === 'resource' &&
                    !['manager', 'partner'].includes(gradeLevel) &&
                    !hasSpecialRole;
                const path = userRoles.isTalentAdvisor ? '/requisitions' : '/';
                const resourcePath = isPodLead ? '/work-packages-pod-lead' : '/resource-dashboard';
                router.push(isResource ? resourcePath : path);
                router.refresh();
            } else {
                console.log('err', res.error);
            }
        } else {
            const res = await sendLoginOtp({ emailId: email });
            if (res.status) {
                setOtpSent(true);
            }
        }
    }

    console.log('email: ', watch('email'));

    return (
        <div className='flex flex-col gap-4 my-2'>
            <InputBox
                id="email"
                name="email"
                dbName="email"
                placeholder="Email"
                value={watch('email')}
                register={register}
                type="text"
                variant="Default"
                isError={!!errors.email?.message}
                errorMessage={errors.email?.message}
                disabled={otpSent}
            />
            {
                otpSent
                && <InputBox
                    id="otp"
                    name="otp"
                    dbName="otp"
                    placeholder="OTP"
                    register={register}
                    type="otp"
                    variant="Default"
                    isError={!!errors.otp?.message}
                    errorMessage={errors.otp?.message}
                />
            }
            <Button
                label={`${otpSent ? 'Verify' : 'Login with '} OTP`}
                onClick={handleSubmit(submitHandler)}
            />

        </div>
    );
}
